module.exports = __webpack_public_path__ + "static/cake-8603babb313c518c0d8d9048efd74f75.jpg";